"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = emphasis;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function emphasis(subject, highlight) {
    var result = [],
        idx,
        testSubject;

    if (!subject || !highlight) {
        return subject;
    }

    highlight = highlight.toLowerCase();
    testSubject = subject.toLowerCase();

    while ((idx = testSubject.indexOf(highlight)) !== -1) {
        result.push(subject.substr(0, idx));
        result.push(_react2.default.createElement(
            "strong",
            { key: result.length },
            subject.substr(idx, highlight.length)
        ));

        subject = subject.substr(idx + highlight.length);
        testSubject = testSubject.substr(idx + highlight.length);
    }

    if (testSubject.length) {
        result.push(subject);
    }

    return _react2.default.createElement(
        "span",
        null,
        result
    );
}
//# sourceMappingURL=text-emphasis.js.map